import { c as _c } from "react/compiler-runtime";
import { AnimatedSection, LazyImage } from '@/components/partials';
import { getLocalizedMetaData, getAppLocale, buildTranslatedRoute } from '@/lib/utils.server';
import { getTranslations } from 'next-intl/server';
import { Link } from '@/i18n/navigation';
import { ArrowRightIcon } from 'lucide-react';
import picture from '@/assets/img/main-pic-00.jpg';
const HomePageContent = async () => {
  const $ = _c(2);
  let t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = Symbol.for("react.early_return_sentinel");
    bb0: {
      const t = await getTranslations();
      const {
        appTitle,
        generalSettings
      } = await getLocalizedMetaData();
      const {
        backendLocale
      } = await getAppLocale();
      const baseRoute = await buildTranslatedRoute(backendLocale, "corporate");
      const translations = generalSettings?.presentationPage?.translations ?? {};
      const firstLocale = Object.keys(translations)[0] ?? null;
      const translation = translations[backendLocale] ?? (firstLocale ? translations[firstLocale] : null);
      const content = translation?.content ?? "";
      const slug = translation?.slug ?? null;
      if (!generalSettings?.presentationPage) {
        t1 = null;
        break bb0;
      }
      t0 = <AnimatedSection animation="scale" startOffset={80} className="mx-auto max-w-7xl px-4 py-10"><div className="grid grid-cols-1 items-start gap-8 lg:grid-cols-2"><div className="relative overflow-hidden rounded-lg shadow-lg"><LazyImage src={picture} alt={appTitle} priority={true} className="h-full w-full object-cover brightness-75 contrast-125" /><div className="from-brand/30 via-primary/20 pointer-events-none absolute inset-0 bg-linear-to-br to-slate-900/40" /></div><div className="flex flex-col space-y-5"><h1 className="text-3xl font-bold lg:text-4xl">{appTitle}</h1><div className="relative"><div className="prose prose-slate dark:prose-invert html-content max-h-80 max-w-none overflow-hidden text-justify leading-relaxed text-gray-500!" dangerouslySetInnerHTML={{
                __html: content
              }} /><div className="from-background pointer-events-none absolute right-0 bottom-0 left-0 h-16 bg-linear-to-t to-transparent" /></div>{slug && <div><Link href={`/${baseRoute}/${slug}`} className="bg-brand hover:bg-brand-darken inline-flex items-center gap-2 rounded px-5 py-2.5 font-semibold text-gray-800 transition-colors">{t("read_more")}<ArrowRightIcon className="h-4 w-4" /></Link></div>}</div></div></AnimatedSection>;
    }
    $[0] = t0;
    $[1] = t1;
  } else {
    t0 = $[0];
    t1 = $[1];
  }
  if (t1 !== Symbol.for("react.early_return_sentinel")) {
    return t1;
  }
  return t0;
};
export default HomePageContent;